module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "icon-instagram.60ec64bf.svg";